module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "id",
      "size": "small"
    },
    model: {
      value: (_vm.params.live_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "live_id", $$v)
      },
      expression: "params.live_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择主播",
      "remote": "",
      "remote-method": _vm.getAnchorList
    },
    on: {
      "change": _vm.handleAnchorChange
    },
    model: {
      value: (_vm.params.anchor_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "anchor_name", $$v)
      },
      expression: "params.anchor_name"
    }
  }, _vm._l((_vm.anchorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.params.anchor_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "anchor_id", $$v)
      },
      expression: "params.anchor_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择店铺",
      "remote": "",
      "remote-method": _vm.getDistributorList
    },
    on: {
      "change": _vm.handleDistibutorChange
    },
    model: {
      value: (_vm.params.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_name", $$v)
      },
      expression: "params.distributor_name"
    }
  }, _vm._l((_vm.distributorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.params.inca_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "inca_id", $$v)
      },
      expression: "params.inca_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "直播标题",
      "size": "small"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "直播商品",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), (false) ? _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "是否录播"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.params.is_record),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_record", $$v)
      },
      expression: "params.is_record"
    }
  }, _vm._l((_vm.isRecordOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择直播状态"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择视频类型"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.params.source_video_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "source_video_type", $$v)
      },
      expression: "params.source_video_type"
    }
  }, _vm._l((_vm.sourceVideoTypeOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择直播分类类型"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择直播分类"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.params.cate_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "cate_id", $$v)
      },
      expression: "params.cate_id"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.cate_name,
        "size": "mini",
        "value": item.cate_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "视频开始时间",
      "ange-separator": "至",
      "end-placeholder": "视频结束时间",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.start_at),
      callback: function($$v) {
        _vm.start_at = $$v
      },
      expression: "start_at"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "上传时间",
      "ange-separator": "至",
      "end-placeholder": "上传时间",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.updateDateChange
    },
    model: {
      value: (_vm.upload_at),
      callback: function($$v) {
        _vm.upload_at = $$v
      },
      expression: "upload_at"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.batchDelete
    }
  }, [_vm._v("批量删除")])], 1), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.exportTitle
    }
  }, [_vm._v("导出标题")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "100",
        "fixed": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editItemsAction(scope.$index, scope.row, false)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-popover', {
            attrs: {
              "placement": "right",
              "width": "250",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "operating-icons"
          }, [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteItemsAction(scope.$index, scope.row)
              }
            }
          }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.selectCount(scope.$index, scope.row)
              }
            }
          }, [_vm._v("查看统计报表")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editCount(scope.$index, scope.row)
              }
            }
          }, [_vm._v("查看操作记录")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.exportData(scope.$index, scope.row.live_id)
              }
            }
          }, [_vm._v("导出报表")]), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleGetPushUrl(scope.row)
              }
            }
          }, [_vm._v("查看推流地址")]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_c('i', {
            staticClass: "iconfont icon-angle-double-right"
          })])], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "live_id",
        "label": "直播ID",
        "width": "70"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sort",
        "label": "排序",
        "width": "90",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "mini"
            },
            on: {
              "change": function($event) {
                return _vm.editItemsSort(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.sort),
              callback: function($$v) {
                _vm.$set(scope.row, "sort", $$v)
              },
              expression: "scope.row.sort"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "edit_status",
        "label": "状态",
        "width": "50"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.edit_status == '1') ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.shelf(scope.$index, scope.row, 2)
              }
            }
          }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (scope.row.edit_status == '2') ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.shelf(scope.$index, scope.row, 1)
              }
            }
          }, [_vm._v("上架")]) : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "cate_id",
        "label": "分类",
        "width": "130",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.cate_id == item.cate_id) ? _c('el-select', {
            attrs: {
              "size": "small",
              "clearable": "",
              "placeholder": "请选择直播分类"
            },
            on: {
              "change": function($event) {
                return _vm.quickEdit(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.cate_id),
              callback: function($$v) {
                _vm.$set(scope.row, "cate_id", $$v)
              },
              expression: "scope.row.cate_id"
            }
          }, _vm._l((_vm.category), function(item) {
            return _c('el-option', {
              key: item.value,
              attrs: {
                "selected": "",
                "label": item.cate_name,
                "size": "mini",
                "value": item.cate_id
              }
            })
          }), 1) : _c('el-select', {
            attrs: {
              "size": "small",
              "clearable": "",
              "placeholder": "请选择直播分类"
            },
            on: {
              "change": function($event) {
                return _vm.quickEdit(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.cate_id),
              callback: function($$v) {
                _vm.$set(scope.row, "cate_id", $$v)
              },
              expression: "scope.row.cate_id"
            }
          }, _vm._l((_vm.category), function(item) {
            return _c('el-option', {
              key: item.value,
              attrs: {
                "label": item.cate_name,
                "size": "mini",
                "value": item.cate_id
              }
            })
          }), 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "speaker",
        "label": "主讲人",
        "width": "90",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.speaker))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "speaker",
        "label": "是否置顶",
        "width": "90",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "1",
              "inactive-value": "0",
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            },
            on: {
              "change": function($event) {
                return _vm.switchAuth(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.is_top),
              callback: function($$v) {
                _vm.$set(scope.row, "is_top", $$v)
              },
              expression: "scope.row.is_top"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "anchor_id",
        "label": "主播",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('router-link', {
            staticClass: "btn-gap",
            attrs: {
              "to": {
                path: _vm.matchInternalRoute('anchorlist'),
                query: {
                  anchor_id: scope.row.anchor_id
                }
              }
            }
          }, [_vm._v(_vm._s(scope.row.anchor.nickname))])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "title",
        "label": "直播标题",
        "width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_bn",
        "label": "直播商品",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleDialogGoods(scope.row, scope.row.live_id)
              }
            }
          }, [_vm._v("查看商品")])]
        }
      }], null, true)
    }), _vm._v(" "), (false) ? _c('el-table-column', {
      attrs: {
        "prop": "is_record",
        "label": "是否录播",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "1",
              "inactive-value": "0",
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            },
            on: {
              "change": function($event) {
                return _vm.switchRecord(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.is_record),
              callback: function($$v) {
                _vm.$set(scope.row, "is_record", $$v)
              },
              expression: "scope.row.is_record"
            }
          })]
        }
      }], null, true)
    }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "cover_image",
        "label": "直播封面",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-popover', {
            attrs: {
              "placement": "right",
              "width": "240",
              "trigger": "hover"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": scope.row.cover_image
            }
          }), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icon_img.png"
            }
          })])], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "source_video_type",
        "label": "视频类型",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return _vm._l((_vm.sourceVideoTypeOption), function(v, k) {
            return (scope.row.source_video_type === v.value) ? _c('el-tag', {
              key: index,
              attrs: {
                "size": "mini",
                "effect": "plain",
                "type": "success"
              }
            }, [_vm._v(_vm._s(v.name))]) : _vm._e()
          })
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "upload_at",
        "label": "上传时间",
        "width": "160",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return (scope.row.upload_at != 0) ? [_vm._v(_vm._s(_vm._f("datetime")(scope.row.upload_at, 'yyyy-MM-dd hh:mm:ss')))] : undefined
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "status",
        "label": "审核状态"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.video_rules_status == 0 && scope.row.video_rules != '') ? _c('el-tag', {
            attrs: {
              "type": "primary"
            }
          }, [_vm._v("待处理")]) : (scope.row.video_rules_status == 1) ? _c('el-tag', {
            attrs: {
              "type": "danger"
            }
          }, [_vm._v("已通过")]) : (scope.row.video_rules_status == 2) ? _c('el-tag', {
            attrs: {
              "type": "warning"
            }
          }, [_vm._v("已拒绝")]) : (scope.row.video_rules_status == 3) ? _c('el-tag', {
            attrs: {
              "type": "warning"
            }
          }, [_vm._v("已下架")]) : _c('el-tag', {
            attrs: {
              "type": "primary"
            }
          }, [_vm._v("无规则")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "规则审核",
        "width": "240"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.video_rules_status == 2) ? _c('el-button', {
            directives: [{
              name: "popover",
              rawName: "v-popover:popover",
              arg: "popover"
            }],
            attrs: {
              "size": "mini",
              "type": "info"
            }
          }, [_c('el-popover', {
            ref: "popover",
            refInFor: true,
            attrs: {
              "placement": "top",
              "width": "400",
              "trigger": "click"
            }
          }, [_c('el-input', {
            attrs: {
              "type": "textarea",
              "rows": 6,
              "disabled": true,
              "value": scope.row.video_rules_reason
            }
          })], 1), _vm._v("\n                            拒绝原因\n                          ")], 1) : _vm._e(), _vm._v(" "), (scope.row.video_rules != '') ? _c('div', [(scope.row.video_rules_status == 0) ? _c('el-button', {
            attrs: {
              "size": "mini",
              "type": "primary",
              "title": scope.row.title_rules
            },
            on: {
              "click": function($event) {
                return _vm.dialogOpen(scope.row.live_id)
              }
            }
          }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.video_rules_status == 0) ? _c('el-button', {
            attrs: {
              "size": "mini",
              "type": "primary",
              "title": scope.row.title_rules
            },
            on: {
              "click": function($event) {
                return _vm.dialogCancel(scope.row.live_id)
              }
            }
          }, [_vm._v("拒绝")]) : _vm._e()], 1) : _vm._e()]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.goodsDialog.goodsTitle,
      "visible": _vm.goodsDialog.goodsVisible,
      "before-close": _vm.handleGoodsDialogCancel
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.goodsDialog, "goodsVisible", $event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "title": "商品列表",
      "type": "info",
      "description": "",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsDialog.dialogLoading),
      expression: "goodsDialog.dialogLoading"
    }],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 23
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsList,
      "tooltip-effect": "dark"
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "btn-gap",
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical_editor') + '/' + scope.row.item_id
            }
          }
        }, [_vm._v(_vm._s(scope.row.item_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v("商品id:" + _vm._s(scope.row.item_id))]), _vm._v(_vm._s(scope.row.item_bn))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.item_from == 'store') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("店铺")]) : (scope.row.item_from == 'shop') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商城")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brief",
      "label": "商品简介",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "市场价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_record",
      "label": "商品图片",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            "height": "240px",
            "text-align": "center"
          }
        }, _vm._l((scope.row.pics), function(v) {
          return _c('img', {
            staticClass: "goods-popover-img",
            staticStyle: {
              "width": "92%"
            },
            attrs: {
              "src": v
            }
          })
        }), 0), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGoodsAction(scope.$index, scope.row )
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.goodsDialog.goodsParams.page,
      "page-sizes": [100, 200, 300],
      "total": _vm.goodsList.total_count,
      "page-size": _vm.goodsDialog.goodsParams.pageSize
    },
    on: {
      "current-change": _vm.handleGoodsDialogCurrentChange,
      "size-change": _vm.handleGoodsDialogSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer position-left",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.goodsDialog.goodsVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.goodsDialog.goodsVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拒绝提现",
      "visible": _vm.canceldialog,
      "close-on-click-modal": false,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.canceldialog = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 6,
      "placeholder": "请输入拒绝原因"
    },
    model: {
      value: (_vm.video_rules_reason),
      callback: function($$v) {
        _vm.video_rules_reason = $$v
      },
      expression: "video_rules_reason"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.canceldialog = false;
      }
    }
  }, [_vm._v("取消操作")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.actionProcessCashWithdrawal(2)
      }
    }
  }, [_vm._v("确认拒绝")])], 1)], 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": "统计报表",
      "width": "40"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.liveLog,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "用户id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_ip",
      "label": "用户ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "首次登录时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userinfo.username",
      "label": "用户昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "观看时长"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.time.day) + "天" + _vm._s(scope.row.time.hour) + "时" + _vm._s(scope.row.time.min) + "分" + _vm._s(scope.row.time.sec) + "秒")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_edit,
      "title": "操作记录",
      "width": "40"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_edit = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.LiveOperationLog,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "admin",
      "label": "操作员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "操作员ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "操作时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.operation_content))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12405b84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12405b84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/list.vue
// module id = 2479
// module chunks = 0